import { render, staticRenderFns } from "./OriginalBLReIssuePop.vue?vue&type=template&id=0940ef98"
import script from "./OriginalBLReIssuePop.vue?vue&type=script&lang=js"
export * from "./OriginalBLReIssuePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0940ef98')) {
      api.createRecord('0940ef98', component.options)
    } else {
      api.reload('0940ef98', component.options)
    }
    module.hot.accept("./OriginalBLReIssuePop.vue?vue&type=template&id=0940ef98", function () {
      api.rerender('0940ef98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/OriginalBLReIssuePop.vue"
export default component.exports